/**
 * Controls submit between nested forms inside Checkout Delivery Component
 */
class DeliveryFormControlState {

    setChildFormSubmitting() {
        this.isChildFormSubmitting = true;
    }

    getChildFormSubmitting() {
        return this.isChildFormSubmitting;
    }

    clearFormSubmitting() {
        this.isChildFormSubmitting = false;
    }
}

module.exports = {
    DeliveryFormControlState,
};



// WEBPACK FOOTER //
// ./src/olycommon/form/delivery-form-control.state.js